import 'css-chunksrc/client/common/preview/zipRenderer/nodes/styles.scss';export default {
  "parentNode": "_parentNode_xxe6l_1",
  "backArrow": "_backArrow_xxe6l_11",
  "name": "_name_xxe6l_17",
  "list": "_list_xxe6l_23",
  "node": "_node_xxe6l_28"
};